import { get } from "./api";
import type { StatusVisita, TipoRegistro, Visita } from "./tipos";

export interface PaginaVisitas {
  itens: Visita[];
  total: number;
  pagina: number;
  porPagina: number;
}

export interface FiltroVisitas {
  status?: StatusVisita | "";
  /** Omitido, a API devolve só visitas — orçamento precisa ser pedido. */
  tipo?: TipoRegistro;
  busca?: string;
  de?: string;
  ate?: string;
  pagina?: number;
  porPagina?: number;
}

export function buscarVisitas(f: FiltroVisitas = {}) {
  const p = new URLSearchParams({
    pagina: String(f.pagina ?? 1),
    porPagina: String(f.porPagina ?? 200),
  });
  if (f.tipo) p.set("tipo", f.tipo);
  if (f.status) p.set("status", f.status);
  if (f.busca) p.set("busca", f.busca);
  if (f.de) p.set("de", f.de);
  if (f.ate) p.set("ate", f.ate);
  return get<PaginaVisitas>(`/api/visitas?${p}`);
}

/** Início e fim do dia de hoje, no fuso local, no formato que a API espera. */
export function intervaloHoje() {
  const ini = new Date();
  ini.setHours(0, 0, 0, 0);
  const fim = new Date(ini.getTime() + 86_400_000 - 1);
  return { de: ini.toISOString(), ate: fim.toISOString() };
}

/** Próximas 3 horas — usado no alerta de ligações de confirmação. */
export function intervaloProximas3h() {
  const agora = new Date();
  return { de: agora.toISOString(), ate: new Date(agora.getTime() + 3 * 3_600_000).toISOString() };
}
